import {
  Paper,
  Container,
  Typography,
  type SxProps,
  type Theme,
} from "@mui/material";
import React from "react";

export interface FormCardProps {
  /** Children to render inside the card */
  children: React.ReactNode;
  /** Title of the form */
  title?: string;
  /** Subtitle/description */
  subtitle?: string;
  /** Maximum width of the container */
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  /** Paper elevation */
  elevation?: number;
  /** Additional padding inside the card */
  padding?: number | string;
  /** Additional sx props for the Paper */
  sx?: SxProps<Theme>;
  /** Whether to wrap in Container */
  useContainer?: boolean;
}

const FormCard: React.FC<FormCardProps> = ({
  children,
  title,
  subtitle,
  maxWidth = "sm",
  elevation = 0,
  padding,
  sx = {},
  useContainer = false,
}) => {
  const cardContent = (
    <Paper
      variant="outlined"
      elevation={elevation}
      sx={{ p: padding ?? { xs: 2.5, sm: 4 }, ...sx }}
    >
      {title && (
        <Typography variant="h4" component="h1" textAlign="left" gutterBottom>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          variant="body1"
          textAlign="left"
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          {subtitle}
        </Typography>
      )}
      {children}
    </Paper>
  );

  if (!useContainer) {
    return cardContent;
  }

  return <Container maxWidth={maxWidth}>{cardContent}</Container>;
};

export default FormCard;
